/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react"
import { History } from "history"
import { createBrowserHistory } from "history"
import AjaxService from "@/services/ajax-service"

import { Message } from "@/containers/ui"

interface MessageFunc {
    (message: Message): void
}

interface UIFunctions {
    setLoading: (loading: boolean) => void
    addSuccessMessage: MessageFunc
    addInfoMessage: MessageFunc
    addWarningMessage: MessageFunc
    addDangerMessage: MessageFunc
    clearMessages: MessageFunc
}

export interface UIState {
    isLoading: boolean
    messagesCount: number
    successMessages: Array<Message>
    infoMessages: Array<Message>
    warningMessages: Array<Message>
    dangerMessages: Array<Message>
}

export interface AjaxServiceProps {
    service: AjaxService
}

export interface HistoryProps {
    history: History
}

export type UIContextProps = UIState &
    AjaxServiceProps &
    HistoryProps &
    UIFunctions

const UIContext = React.createContext<UIContextProps>({
    history: createBrowserHistory(),
    service: new AjaxService(),
    isLoading: false,
    messagesCount: 0,
    successMessages: [],
    infoMessages: [],
    warningMessages: [],
    dangerMessages: [],
    setLoading: () => {},
    addSuccessMessage: () => {},
    addInfoMessage: () => {},
    addWarningMessage: () => {},
    addDangerMessage: () => {},
    clearMessages: () => {}
})

export default UIContext
